import React, {useEffect, useState} from 'react';
import styled from 'styled-components';
import arrowIconUp from "../../../images/up.svg";
import arrowIconDown from "../../../images/down.svg";
import { useLexicon } from "../../../hooks/useLexicon";
import { useDispatch, useSelector } from 'react-redux';
import { $apiV1 } from '../../../config/api';
import { getUserProfile, invalidateUserProfile } from '../../../helpers/userProfile';
import { userActions } from '../../../store/user/userSlice';
import { Input } from '../../../pages/tournametns/player/ui/Input';

export const VideoSettingsWrapper = styled.div`
  position: relative;
  z-index: 30;
  isolation: isolate;
`;

export const VideoSettings = styled.div`
  border-radius: 1px;
  border: 1px solid rgba(44, 50, 48, 1);
  opacity: 1;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 196px;
  height: 40px;
  padding: 4px 10px;
  cursor: pointer;

  img {
    transform: rotate(90deg);
  }

  h3 {
    opacity: 1;
    color: ${(props) => props.theme.white};
    font-family: "SatoshiMedium";
    font-size: 16px;
    font-weight: 500;
    font-style: Medium;
    letter-spacing: 0px;
    text-align: left;
    line-height: 24px;
  }
`;

export const VideoSettingsContent = styled.div`
  position: absolute;
  border-radius: 2px;
  opacity: 1;
  background-color: ${(props) => props.theme.lines};
  width: 218px;
  z-index: 40;
`;

export const VideoContent = styled.div`
  padding: 20px;

  h3 {
    opacity: 1;
    color: ${(props) => props.theme.blueish2};
    font-family: "SatoshiMedium";
    font-size: 16px;
    font-weight: 500;
    font-style: Medium;
    letter-spacing: 0.5px;
    text-align: left;
    line-height: 24px;
    margin-bottom: 10px;
  }

  button {
    border-radius: 1px;
    opacity: 1;
    background-color: ${(props) => props.theme.green};
    width: 100%;
    height: 30px;
    border: none;
    opacity: 1;
    color: rgba(4, 8, 2, 1);
    font-family: "SpaceGrotesk";
    font-size: 16px;
    font-weight: 700;
    font-style: Bold;
    letter-spacing: 0.5px;
    text-align: center;
    line-height: 24px;
    text-transform: uppercase;
    margin-top: 20px;
    cursor: pointer;
  }

  label {
    opacity: 1;
    color: rgba(207, 218, 230, 1);
    font-family: "SatoshiBold";
    font-size: 16px;
    font-weight: 700;
    font-style: Bold;
    letter-spacing: 0px;
    text-align: left;
    line-height: 24px;

    display: flex;
    flex-direction: row;
    gap: 10px;

    #specifyColor {
      accent-color: ${(props) => props.theme.green};
    }
  }
`;

export const OffsetFields = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;

  input {
    border-radius: 1px;
    border: 1px solid rgba(44, 50, 48, 1);
    opacity: 1;
    width: 100%;
    background: transparent;
    height: 40px;
    color: #fff;
    outline: none;

    opacity: 1;
    color: ${(props) => props.theme.blueish};
    font-family: "SatoshiBold";
    font-size: 16px;
    font-weight: 700;
    font-style: Bold;
    letter-spacing: 0px;
    text-align: center;
    line-height: 24px;
  }
`;

export const ZonesWrapper = styled.div`
  border-radius: 1px;
  border: 1px solid rgba(44, 50, 48, 1);
  opacity: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 40px;
  padding: 0 10px;
  margin-top: 20px;
  position: relative;

  h3 {
    opacity: 1;
    color: ${(props) => props.theme.white};
    font-family: "SatoshiMedium";
    font-size: 16px;
    font-weight: 500;
    font-style: Medium;
    letter-spacing: 0px;
    text-align: left;
    line-height: 24px;
    margin: 0;
  }
`;

export const ZoneOpenContent = styled.div`
  background: red;
  position: absolute;
  border: 1px solid rgba(44, 50, 48, 1);
  background: ${(props) => props.theme.lines};
  top: 100%;
  left: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  z-index: 999;
`;

const ZoneOption = styled.div`
  display: inline-block;
  margin-right: 10px;
`;

const VideoSettingsComponent = ({
  showDirection,
  setShowDirection,
  selectedZones,
  handleZoneSelection,
  zoneOpen,
  setZoneOpen,
  user,
  showZones = true,
}) => {
  const l = useLexicon();
  const [videoSettingsOpen, setVideoSettingsOpen] = useState(false);
  const { offset_range_begin = 10, offset_range_end = 10, merge_offset = 0 } = useSelector(state => state.user.userProfile);
  // Use string state to allow intermediate values (like empty string while typing)
  const [inputBegin, setInputBegin] = useState(String(offset_range_begin));
  const [inputEnd, setInputEnd] = useState(String(offset_range_end));   
  const [inputMerge, setInputMerge] = useState(String(merge_offset));
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);
  const dispatch = useDispatch();

  const handleOffset = async (event) => {
    event?.preventDefault();
    console.log(user);
    // Validate and clamp values before saving
    let beginValue = +inputBegin;
    let endValue = +inputEnd;
    let mergeValue = +inputMerge;

    if (isNaN(beginValue) || beginValue < 1) beginValue = 1;
    if (isNaN(endValue) || endValue < 1) endValue = 1;
    if (isNaN(mergeValue) || mergeValue < 0) mergeValue = 0;
    if (mergeValue > 15) mergeValue = 15;

    setLoading(true);
    setError(null);
    setSuccess(false);
    try {
        await $apiV1.patch(`/users/profile_settings/${user}/`, {
        offset_range_begin: beginValue,
        offset_range_end: endValue,
        merge_offset: mergeValue,
      });
      invalidateUserProfile(); // settings changed → next profile read must be fresh

      // Update local inputs with validated values
      setInputBegin(String(beginValue));
      setInputEnd(String(endValue));
      setInputMerge(String(mergeValue));

      dispatch(userActions.changeOffsetBegin(beginValue));
      dispatch(userActions.changeOffsetEnd(endValue));
      dispatch(userActions.changeMergeOffset(mergeValue));
      setSuccess(true);
    } catch (err) {
        console.log(err);
      setError(err.message || 'Error updating offset');
    } finally {
      setLoading(false);
      setTimeout(() => setSuccess(false), 2000);
    }
  };

    useEffect(() => {
        function handleFocus() {
            // Refresh on focus to pick up settings changed elsewhere (force bypasses cache).
            getUserProfile(true).then(res => {
                setInputBegin(String(res.data.offset_range_begin ?? ''));
                setInputEnd(String(res.data.offset_range_end ?? ''));
                setInputMerge(String(res.data.merge_offset ?? ''));
            });
        }
        window.addEventListener('focus', handleFocus);
        return () => window.removeEventListener('focus', handleFocus);
    }, []);

  return (
    <VideoSettingsWrapper>
      <VideoSettings onClick={() => setVideoSettingsOpen(!videoSettingsOpen)}>
        <h3>{l(27)}</h3>
        <img src={arrowIconUp} />
      </VideoSettings>
      {videoSettingsOpen && (
        <VideoSettingsContent>
          <VideoContent>
            <form onSubmit={handleOffset}>
              <OffsetFields>
                <Input
                  type="number"
                  value={inputBegin}
                  label={l(1030)}
                  labelStyle={{opacity: 0.5}}
                  style={{height: '20px', textAlign: 'left', width: 'calc(100% - 10px)', paddingLeft: '10px'}}
                  onChange={(e) => setInputBegin(e.target.value)}
                />
                <Input
                  type="number"
                  value={inputEnd}
                  label={l(1031)}
                  labelStyle={{opacity: 0.5}}
                  style={{height: '20px', textAlign: 'left', width: 'calc(100% - 10px)', paddingLeft: '10px'}}
                  onChange={(e) => setInputEnd(e.target.value)}
                />
                <Input
                  type="number"
                  value={inputMerge}
                  label={l(1112)}
                  min={0}
                  max={15}
                  divWidth="100%"
                  labelStyle={{opacity: 0.5}}
                  style={{height: '20px', textAlign: 'left', width: 'calc(100% - 10px)', paddingLeft: '10px'}}
                  onChange={(e) => setInputMerge(e.target.value)}
                />
              </OffsetFields>
              <button type="submit" disabled={loading}>
                {loading ?  'Saving...' : l(999)}
              </button>
            </form>
            {success && <div style={{color: 'green', marginTop: 8}}>{ 'Saved!'}</div>}

            <h3 style={{ marginTop: "20px" }}>{l(423)}</h3>
            <label>
              <input
                type="checkbox"
                id="specifyColor"
                checked={showDirection}
                onChange={() => setShowDirection(!showDirection)}
              />
              {l(421)}
            </label>

            {showZones && (
              <ZonesWrapper onClick={() => setZoneOpen(!zoneOpen)}>
                <h3>{l(450)}</h3>
                <img src={zoneOpen ? arrowIconUp : arrowIconDown} />

                {zoneOpen && (
                  <ZoneOpenContent>
                    {[3, 6, 12, 14, 18].map((zone) => (
                      <ZoneOption key={zone}>
                        <label>
                          <input
                            type="checkbox"
                            checked={selectedZones.includes(zone)}
                            onChange={() => handleZoneSelection(zone)}
                          />
                          {l(450)} {zone}
                        </label>
                      </ZoneOption>
                    ))}
                  </ZoneOpenContent>
                )}
              </ZonesWrapper>
            )}
          </VideoContent>
        </VideoSettingsContent>
      )}
    </VideoSettingsWrapper>
  );
};

export default VideoSettingsComponent; 
